module.exports = __webpack_public_path__ + "img/logo-occitanie.c975a4a5.png";